/* NIVIA MAISON — rolagem infinita na coleção.

   O tema só tem paginação por botão. Aqui a próxima página é buscada
   quando o rodapé da grade se aproxima da tela e os cards são anexados
   ao final — o cliente não clica em nada.

   Sem biblioteca: fetch + DOMParser. A paginação original vira o
   fallback (fica visível se o JS falhar) e some quando assumimos. */
(function () {
  if (window.nmInfiniteReady) return;
  window.nmInfiniteReady = true;

  var GRID = '#product-grid';
  var PAGINATION = '.pagination-wrapper, .pagination, nav[role="navigation"].pagination';

  /* Menor página maior que `after` dentro de um bloco de paginação.
     A página atual costuma vir como <span>, não <a>, então procurar
     "a página seguinte" é mais confiável que procurar um número exato. */
  function findNext(scope, after) {
    if (!scope) return null;
    var links = scope.querySelectorAll('a[href]');
    var best = null;
    var bestPage = Infinity;
    for (var i = 0; i < links.length; i++) {
      var u;
      try { u = new URL(links[i].href, window.location.origin); } catch (e) { continue; }
      var p = parseInt(u.searchParams.get('page') || '0', 10);
      if (p > after && p < bestPage) { bestPage = p; best = u.href; }
    }
    return best ? { url: best, page: bestPage } : null;
  }

  function init() {
    var grid = document.querySelector(GRID);
    if (!grid) return;

    var pager = document.querySelector(PAGINATION);
    if (!pager) return;

    /* A página atual sai da URL uma única vez. Daqui em diante quem
       manda é este contador — ler window.location a cada rodada era o
       que travava a grade na página 2 (a URL nunca muda). */
    var currentPage = parseInt(
      new URL(window.location.href).searchParams.get('page') || '1',
      10
    );

    var next = findNext(pager, currentPage);
    if (!next) return;

    var loading = false;
    pager.style.display = 'none';

    var sentinel = document.createElement('div');
    sentinel.className = 'nm-infinite__sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    grid.parentNode.insertBefore(sentinel, grid.nextSibling);

    var status = document.createElement('p');
    status.className = 'nm-infinite__status';
    status.setAttribute('role', 'status');
    sentinel.appendChild(status);

    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) load();
    }, { rootMargin: '600px 0px' });

    function stop() {
      status.textContent = '';
      io.disconnect();
    }

    /* Anexar não dispara o observer de novo: se o sentinela continuar
       visível depois da carga, ninguém pede a página seguinte. Por isso
       reavaliamos a posição na mão a cada rodada. */
    function maybeContinue() {
      if (!next || loading) return;
      var rect = sentinel.getBoundingClientRect();
      if (rect.top <= window.innerHeight + 600) load();
    }

    function load() {
      if (loading || !next) return;
      loading = true;
      status.textContent = 'Loading more';

      var url = next.url;
      var page = next.page;

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector(GRID);
          if (!newGrid) throw new Error('grid not found');

          Array.prototype.slice.call(newGrid.children).forEach(function (item) {
            grid.appendChild(item);
          });

          /* Os swatches de família do card trazem script próprio; um
             evento avisa quem precisa reinicializar. */
          document.dispatchEvent(new CustomEvent('nm:products-appended'));

          currentPage = page;
          next = findNext(doc.querySelector(PAGINATION), currentPage);
          loading = false;

          if (!next) { stop(); return; }
          status.textContent = '';
          setTimeout(maybeContinue, 60);
        })
        .catch(function () {
          /* falhou: devolve a paginação normal para o cliente não ficar preso */
          pager.style.display = '';
          loading = false;
          stop();
        });
    }

    io.observe(sentinel);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
